import { z } from 'zod';

export const contactProcedureRelationTypeSchema = z.enum([
  'suggestion',
  'selected',
  'extracted',
  'previousSurgery',
  'inContract',
]);

// Represent the type of relation between a contact and a procedure.
export type ContactProcedureRelationType = z.infer<
  typeof contactProcedureRelationTypeSchema
>;
